import {
  mapCultureSourceToGridRow,
  mapFinanceSourceToGridRow,
  mapFoodSourceToGridRow,
  mapGa4SourceToGridRow,
  mapRealEstateSourceToGridRow,
  mapTransportSourceToGridRow,
  mapVendorDirectorySourceToGridRow,
  mapVehicleMarketSourceToGridRow,
  mapWeatherSourceToGridRow,
} from "./mapDataSourceGridRow";

export function buildDataSourceCatalog({
  realEstateSources = [],
  weatherSources = [],
  cultureSources = [],
  vehicleMarketSources = [],
  financeSources = [],
  ga4Sources = [],
  foodSources = [],
  transportSources = [],
  vendorDirectorySources = [],
} = {}) {
  return [
    ...realEstateSources.map(mapRealEstateSourceToGridRow),
    ...weatherSources.map(mapWeatherSourceToGridRow),
    ...cultureSources.map(mapCultureSourceToGridRow),
    ...vehicleMarketSources.map(mapVehicleMarketSourceToGridRow),
    ...financeSources.map(mapFinanceSourceToGridRow),
    ...ga4Sources.map(mapGa4SourceToGridRow),
    ...foodSources.map(mapFoodSourceToGridRow),
    ...transportSources.map(mapTransportSourceToGridRow),
    ...vendorDirectorySources.map(mapVendorDirectorySourceToGridRow),
  ];
}

export function findDataSourceInCatalog(catalog, domainId, sourceKey) {
  const domain = String(domainId || "").trim();
  const key = String(sourceKey || "").trim();
  if (!domain || !key) return null;

  const inDomain = (catalog || []).filter((source) => String(source.domainId || "") === domain);
  const byKey = inDomain.find((source) => String(source.sourceKey || "") === key);
  if (byKey) return byKey;

  const byCodeOrId = inDomain.filter(
    (source) => String(source.sourceCode || "") === key || String(source.id || "") === key
  );
  if (byCodeOrId.length <= 1) {
    return byCodeOrId[0] || null;
  }

  // Health links often use shared source_code (e.g. coninsa_public). Prefer the section
  // that ran most recently so Last Result matches Recent runs.
  return byCodeOrId
    .slice()
    .sort((left, right) => {
      const leftTime =
        Date.parse(left.lastRunAt || left.latestRun?.startedAt || left.latestRun?.finishedAt || 0) ||
        0;
      const rightTime =
        Date.parse(
          right.lastRunAt || right.latestRun?.startedAt || right.latestRun?.finishedAt || 0
        ) || 0;
      return rightTime - leftTime;
    })[0];
}
